<template>
    <Tab :tabs="[i18n.t('charts.line'), i18n.t('charts.bar')]" :initialTab="i18n.t('charts.line')"
        v-slot="{ selectedTab }">
        <TabContent :name="i18n.t('charts.line')" :selectedTab="selectedTab">
            <line-chart :chartData="RegulationsChartData" />
        </TabContent>
        <TabContent :name="i18n.t('charts.bar')" :selectedTab="selectedTab">
            <bar-chart :chartData="RegulationsChartData" />
        </TabContent>
    </Tab>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, watch, computed, Ref } from "vue";

import { Chart, registerables } from "chart.js";
import { useGlobal } from "@/composables/global/useGlobal";

import Tab from '@/components/tabs/Tab.vue';
import TabContent from '@/components/tabs/TabContent.vue';
import i18n from "@/i18n/index"
Chart.register(...registerables);
import {
    Regulation
} from "@/interfaces/cashReport";

export default defineComponent({
    name: "CustomLineChart",

    components: {
        TabContent,
        Tab
    },

    props: {
        Regulations: {
            type: Array as () => Regulation[],
            default: null
        }
    },

    setup(props) {
        const { Regulations } = toRefs(props) as {
            Regulations: Ref<Regulation[]>;
        };
        const { getColorByIndex, getListMonths, getDateRangeBefore } = useGlobal();

        const months = ref(getListMonths());
        // Reactive reference for chart data
        const RegulationsChartData = ref({
            labels: [] as string[], // Initialize labels as an empty array of strings
            pluginsTitle: '' as string,
            scalesX: '' as string,
            scalesY: '' as string,
            datasets: [] as Array<{
                label: string;
                data: number[];
                borderColor: string;
                backgroundColor: string;
                borderWidth: number;
                tension: number;
            }>,
        });

        const groupedByYearRegulation = computed(() => {
            if (!Regulations.value || Regulations.value.length === 0) return {};

            return Regulations.value.reduce<Record<string, Record<string, number>>>(
                (acc, sub: Regulation) => {
                    if (!acc[sub.year]) acc[sub.year] = {};
                    acc[sub.year][sub.month_key] = (sub?.amount_paid) ? sub.amount_paid : sub.total_amount;
                    return acc;
                },
                {},
            );
        });

        // Watch for changes in groupedByYear or months
        watch(
            groupedByYearRegulation,
            (val) => {
                if (!val) return;

                RegulationsChartData.value = {
                    pluginsTitle: i18n.t('views.clients.encaissements.chart_years'),
                    scalesX: i18n.t('symbole.month'),
                    scalesY:
                        i18n.t('views.clients.encaissements.income') +
                        " (" +
                        i18n.t('symbole.currency.mad') +
                        ")",
                    labels: months.value ?? [],

                    datasets: Object.entries(val).map(([year, data], index) => {
                        const color = getColorByIndex(index);

                        return {
                            label: `${year}`,
                            data: months.value.map((_, i) => {
                                const monthKey = String(i + 1).padStart(2, "0");
                                return data?.[monthKey] || 0;
                            }),
                            borderColor: color,
                            backgroundColor: color,
                            borderWidth: 2,
                            tension: 0.4,
                        };
                    }),
                };
            },
            {
                immediate: true,
                deep: true,
            },
        );

        console.log("RegulationsChartData")
        console.log(RegulationsChartData)
        return {
            i18n,
            RegulationsChartData,
        };
    },
});
</script>